import React from 'react';
import { TextField } from '@mui/material';

function ReadOnlyBarSmall({ currentValue, placeholder }) {
    return (
        <TextField
            variant="outlined"
            value={currentValue}
            size="small"
            placeholder={placeholder}
            disabled
            sx={{
                fontSize: '14px',
                overflow: 'auto',
                width: '40%', 
                backgroundColor: '#f0f0f0', // Gray background
                "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: '#b0b0b0', // Light gray border
                },
            }}
            InputProps={{
                readOnly: true,
                sx: {
                    fontSize: 13,
                    padding: '8px',
                },
            }}
            InputLabelProps={{
                sx: {
                    fontSize: 13,
                    padding: '8px',
                },
            }}
        />
    );
}

export default ReadOnlyBarSmall;
